<template>
    <div class="modal fade" 
        :class="this.modalPosition" 
        :id="modalID" 
        :aria-labelledby="theModalLabel" 
        tabindex="-1"
        aria-hidden="true"
        @click.selfs="attemptClose">

        <div class="np-task-modal modal-dialog modal-dialog-centered w-100" :class="modalClass">
            <div class="np-loading" v-if="isLoading"> . . . </div>
            <div class="p-0 m-0 w-100 h-100">

                <div class="modal-content shadow" @click.stop>
                    <div class="modal-header np-pl-0 np-pt-2 np-pb-2" :style="{ 'border-color': status.color != '#000000' ? status.color : null }">
                        <div class="np-group align-items-center np-flex-1" v-if="!isSubtaskVisible">
                            <span class="np-bullet np-mr-2" :style="{ 'background-color': status.color != '#000000' ? status.color : null }"></span>
                            <span>{{ status.title }}</span>
                        </div>
                        <div class="np-group align-items-center np-flex-1" v-if="isSubtaskVisible">
                            <button type="button" class="np-btn np-outline me-3" @click="closeSubtask">
                                <svg class="icon"><use href="@/assets/images/icons/arrow-left.svg#icon"></use></svg> 
                                {{ $t("UI.task.backToTask") }}
                            </button>                             
                        </div>                        
                        <div class="np-group align-items-center">
                            <button type="button" class="np-btn np-outline me-3" @click="callShowMoveTo(this.taskData.id)" v-if="!isSubtaskVisible">
                                <svg><use href="@/assets/images/icons/calendar-move.svg#icon"></use></svg> 
                            </button>                             
                            <button type="button" class="np-btn np-inactive me-3" v-if="!isSubtaskVisible">
                                <svg><use href="@/assets/images/icons/chain.svg#icon"></use></svg> 
                            </button>                                                            
                            <button type="button" class="np-btn np-outline me-3" @click="callShowArch(3, this.taskData.id)" v-if="!isSubtaskVisible">
                                <svg><use href="@/assets/images/icons/archive.svg#icon"></use></svg> 
                            </button>
                            <button type="button" class="np-btn np-danger np-outline me-3" @click="callShowDel(3, this.taskData.id)" v-if="!isSubtaskVisible">
                                <svg><use href="@/assets/images/icons/trash.svg#icon"></use></svg> 
                            </button>                         
                            <button type="button" class="np-btn me-3" @click="complete" :class="isTaskCompleted ? 'np-success' : 'np-gray'">
                                <svg v-if="isTaskCompleted" class="icon"><use href="@/assets/images/icons/checked2.svg#icon"></use></svg>
                                <svg v-else class="icon"><use href="@/assets/images/icons/task-incomplete.svg#icon"></use></svg>                                
                                {{ !isTaskCompleted ? $t("UI.task.complete") : $t("UI.task.completed") }}
                            </button>                             
                            <button type="button" class="np-btn np-outline me-3" @click="close">
                                <svg><use href="@/assets/images/icons/done.svg#icon"></use></svg> 
                            </button>                              
                            <button type="button" class="np-btn np-outline" data-bs-dismiss="modal" aria-label="Закрыть" v-if="!isSubtaskVisible">
                                <svg><use href="@/assets/images/icons/close3.svg#icon"></use></svg> 
                            </button>
                            <button type="button" class="np-btn np-outline"  @click="closeSubtaskWithoutSaving" v-if="isSubtaskVisible">
                                <svg><use href="@/assets/images/icons/close3.svg#icon"></use></svg> 
                            </button>                            
                        </div>
                    </div>
                    <div class="modal-body ps-0 pe-0">
                        <div class="row p-0 m-0 w-100 h-100">
                            <div class="col p-0" v-if="!isSubtaskVisible">
                                <div class="blocker" @click.self="closeSubtask()"></div>
                                <div class="h-100">
                                    <CobaltTaskForm 
                                        ref="taskForm"                                     
                                        :activeUser="this.projectInfo.activeUser"
                                        :taskData="this.taskData"
                                        :projectUsers="this.projectUsers"
                                        :projectInfo="projectInfo"
                                        @showModSubtask="showModSubtask"
                                        @callViewer="callViewer"
                                        @callProgress="callProgressModal"
                                        @refreshForm="refreshParent"
                                        @close="close"
                                    />
                                </div>
                            </div>
                            <div class="col p-0" v-if="this.isSubtaskVisible">
                                <div class="h-100">
                                    <CobaltSubTaskForm 
                                        ref="subTaskForm"
                                        :activeUser="this.projectInfo.activeUser"
                                        :taskData="this.subTaskData"
                                        :projectUsers="this.projectUsers"
                                        :parentId="this.taskData.id"
                                        :projectInfo="projectInfo"
                                        @callViewer="callViewer"
                                        @callProgress="callProgressModal"
                                        @refreshForm="refreshParent"
                                    />
                                </div>
                            </div>
                        </div>                            
                    </div>
                </div>
                
            </div>
        </div>
    </div>
    <ViewerModal modalID="modalIDVwr" ref="VwrModal" />
    <TaskProgressModal 
        modalID="modalIDProgress" 
        ref="ProgressModal" 
        @setProgress="doSetProgress"
    />
</template>

<script>
import CobaltTaskForm from "@/components/dashboard/parts/CobaltTaskForm.vue"
import CobaltSubTaskForm from "@/components/dashboard/parts/CobaltSubTaskForm.vue"
import ViewerModal from "@/components/modals/ViewerModal.vue"
import TaskProgressModal from "./TaskProgressModal.vue"

import { mapGetters, mapActions } from 'vuex'
import { Modal } from "bootstrap"
import { ref, reactive  } from 'vue'

export default {
    components: {
        CobaltTaskForm,
        CobaltSubTaskForm,
        ViewerModal,
        TaskProgressModal
    },
    props: {
        modalID: {
            type: String,
            required: true
        },
        modalSize: {
            type: String,
            default: ''  // или любой другой дефолт
        },
        modalPosition: {
            type: String,
            default: ''
        },
        status: {
            type: Object,
            default: {
                name: "",
                id: 0
            }
        },
        projectInfo: {
            type: Object,
            default: {}
        },
        taskData: {
            type: Object,
            required: true
        },
        projectUsers: {
            type: Array,
            required: true
        }          
    },    
    data() {
        return {
            subTaskData: {
                parentName: '',
                statusName: '',
                id: 0,
                title: '',
                description: '',
                status_id: '',
                parent_id: 0,
                position: '',
                weight: 0,
                color: '#000000',
                errorText: '',
                date_create: 0,
                date_planned_end: '',
                date_planned_start: '',
                author: {},
                performer: [],
                files: [],
                priority: 0
            },  
            files: [],             
            theModal: null,
            theModalLabel: null,
            isSubtaskVisible: false,
            isLoading: false,
            isClosing: false,
            isSubTaskClosing: false,
            visibleSubtaskId: 0
        }
    },
    computed: {
        modalClass: {
            get() {
                return this.isSubtaskVisible ? this.modalSize + " double" : this.modalSize
            }
        },
        isTaskCompleted: {
            get() {
                if (this.isSubtaskVisible) {
                    return !!this.subTaskData.date_actual_end
                } else {
                    return !!this.taskData.date_actual_end
                }
            }
        }
    }, 
    mounted: function () {
        var IdModal = '#' + this.$props.modalID
        this.theModalLabel = this.modalID + "Label"
        this.theModal = new Modal(IdModal, {backdrop: true})

        const modalElement = document.getElementById(this.$props.modalID)

        modalElement.addEventListener('hide.bs.modal', (event) => {
            if (this.isSubtaskVisible) {
                event.preventDefault()
                if (!this.isSubTaskClosing)
                    this.closeSubtask()
            } else {
                this.$emit('closeModal')
            }
        })
    },
    watch: {
        'taskData.subtask': {
            handler(newSubtasks) {
                this.refreshSubTask()
            },
            deep: true
        }
    },    
    methods: {
        ...mapActions('board', ['updatTsk', 'updatTskDate', 'clearTskDate', 'delTsk', 'archTsk', 'listPerformers', 'assignPerformer', 'detachPerformer', 'listControllers', 'assignController', 'detachController', 'uploadFiles', 'deleteFile', 'completeTask', 'completeSubTask']),
        
        async shows(activeTaskTab="params", activeSubTaskID=null) {
            this.isSubtaskVisible = false;
            this.$refs.taskForm.initialize(activeTaskTab)

            await this.$nextTick() // Ждем следующий тик, чтобы гарантировать прогрузку props

            if (activeSubTaskID) {          
                this.showModSubtask(activeSubTaskID, this.taskData.id)
            }

            this.theModal.show()
        },
        hide() {
            if (this.isClosing) return
            this.theModal.hide()
        },
        attemptClose(event) {
            if (this.isSubtaskVisible) {
                this.closeSubtask()
            } else {
                this.close()
            }
        },
        async close() {
            if (this.isSubtaskVisible) {
                this.closeSubtask()
                return
            }

            let updateResult = await this.updateTask()

            if (updateResult) {
                this.taskData.id = updateResult.id
            }

            await this.$refs.taskForm.updateTaskDate()
            await this.$refs.taskForm.clearTaskDate()

            this.isClosing = true
            this.$emit('closeModal')
        },
        async closeSubtaskWithoutSaving() {
            this.isSubTaskClosing = true     

            this.isSubtaskVisible = false
            this.isSubTaskClosing = false

            this.visibleSubtaskId = 0
        },        
        async closeSubtask() {
            this.isSubTaskClosing = true
            let updateResult = await this.updateSubTask()

            if (updateResult) {
                this.subTaskData.id = updateResult.id

                await this.$refs.subTaskForm.updateTaskDate()
                await this.$refs.subTaskForm.clearTaskDate()                  
            }         

            this.isSubtaskVisible = false
            this.isSubTaskClosing = false
            this.visibleSubtaskId = 0
        },
        async refreshParent() {
            await this.$emit('refresh')
            if (this.isSubtaskVisible) {
                this.refreshSubTask()        
            }
        },
        refreshSubTask() {
            const foundSubtask = this.taskData.subtask.find(elementT => elementT.id === this.visibleSubtaskId)
            if (foundSubtask) {
                this.subTaskData = {...foundSubtask}
            }
        },
        createNewSubTask() {
            return {
                parentName: '',
                statusName: '',
                id: 0,
                title: '',
                description: '',
                status_id: '',
                parent_id: 0,
                position: '',
                weight: 0,
                color: '#000000',
                errorText: '',
                date_create: 0,
                date_planned_end: '',
                date_planned_start: '',
                date_actual_end: '',
                author: {},
                performer: [],
                files: [],
                priority: 0
            }
        },         
        showModSubtask(id, parent_id) {
            if (id > 0) {
                const foundSubtask = this.taskData.subtask.find(elementT => elementT.id === id)
                if (foundSubtask) {
                    this.subTaskData = {...foundSubtask}
                }
            } else {
                this.subTaskData = this.createNewSubTask()
                this.subTaskData.parent_id = parent_id
            }

            this.isSubtaskVisible = true
            this.visibleSubtaskId = id

            this.$nextTick(() => {
                if (this.$refs.subTaskForm) {
                    this.$refs.subTaskForm.initialize()
                }
            })
            
        }, 
        async updateTask() {
            let updateResult = await this.$refs.taskForm.updateTask()
            await this.refreshParent()
            return updateResult
        }, 
        async updateSubTask() {
            let updateResult = await this.$refs.subTaskForm.updateSubTask()
            await this.refreshParent()
            return updateResult
        },     
        async complete() {
            //this.isLoading = true
            
            if (this.isSubtaskVisible) {
                await this.completeSubTask( { complete: !!!this.subTaskData.date_actual_end, id: this.subTaskData.id } )
                // заглушка
                this.subTaskData.date_actual_end = this.subTaskData.date_actual_end ? 0 : 1                
            } else {
                await this.completeTask( { complete: !!!this.taskData.date_actual_end, id: this.taskData.id } )
                // заглушка
                this.taskData.date_actual_end = this.taskData.date_actual_end ? 0 : 1
            }

            await this.refreshParent()

            //this.isLoading = false
        },                         
        callShowMoveTo(task_id) {
            this.$emit('closeModal')
            this.$emit('showMoveTo', task_id)
        },
        callShowArch(type, task_id) {
            this.$emit('closeModal')
            this.$emit('showArch', type, task_id)
        },
        callShowDel(type, task_id) {
            this.$emit('closeModal')
            this.$emit('showDel', type, task_id)
        },
        callViewer(id, files) {
            this.$refs.VwrModal.shows(id, [...files])
        },
        callProgressModal() {
            if (this.isSubtaskVisible) {
                this.$refs.ProgressModal.shows(this.subTaskData.completion_percent)
            } else {
                this.$refs.ProgressModal.shows(this.taskData.completion_percent)
            }
        },
        async doSetProgress(_progress) {
            if (this.isSubtaskVisible) {
                this.subTaskData.completion_percent = _progress
            } else {
                this.taskData.completion_percent = _progress
            }
        }
    }
}
</script>

<style>
    .modal {
        backdrop-filter: blur(5px);
    }
</style>